import api from './api';

// Validate Business Token
export const validateBusinessToken = async (businessToken) => {
  const { data } = await api.get(`/feedback/token/${businessToken}`);
  return data.data;
};

// Submit Feedback
export const submitFeedback = async ({ business_token, feedback_id = null, question_key = null, response = null, is_complete = false }) => {
  const payload = {
    business_token,
    feedback_id,
    question_key,
    response, 
    is_complete,
  };

  const { data: responseData } = await api.post('/feedback', payload);
  console.log(responseData.data);
  
  return responseData.data;
};

// Get Feedback for a Business
export const getFeedbacks = async (businessId, page, limit, startDate, endDate) => {
  const response = await api.get(`/feedback/${businessId}`, {
    params: { page, limit, startDate, endDate },
  });
  return response.data.data;
};

// Get Detailed Feedback Statistics with Date Filters & Comparison
export const getDetailedFeedbackStats = async (businessId, startDate, endDate, compareKey1, compareKey2) => {
  const params = { startDate, endDate, compareKey1, compareKey2 }; // Construct query params
  const { data } = await api.get(`/feedback/stats/${businessId}`, { params });
  return data.data;
};

// Get Recognition Names
export const getRecognitionNames = async (businessId) => {
  const { data } = await api.get(`/feedback/recognitionNames/${businessId}`);
  return data.data;
};

// Delete All Feedback for a Business
export const deleteFeedbackForBusiness = async (businessId) => {
  const { data } = await api.delete(`/feedback/${businessId}`);
  return data.message; // Return success message from the API
};
